import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.css']
})
export class ImageUploaderComponent implements OnInit {

  @Input() src;
  fileToUpload: File = null;
  @Output() input:EventEmitter<string>=new EventEmitter();
  constructor() { }

  ngOnInit() {

  }
  showPopover(e) {

  }
  handleBaseFileInput(files: FileList) {
    this.fileToUpload = <File>files.item(0);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      // this.modelProductAttribute.BaseImage = event.target.result;
      this.input.emit(event.target.result);
    }

    reader.readAsDataURL(this.fileToUpload);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/image-uploader/image-uploader.component.ts